module.exports = __webpack_public_path__ + "img/u58.263c9b98.png";